<template>
    <div class="row" id="share-activity">
        <div class="col-md-12">
            <BarChart :chart-data="activityDataCollection" :options="options" :width="1000"></BarChart>
        </div>
    </div>
</template>
<script>
    import BarChart from "../../../components/Charts/BarChart";

    export default {
        name: 'calendar',
        components: {
            BarChart
        },
        props: [],
        data () {
            return {
                activityDataCollection: null,
                options: {
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                color: "rgba(0, 0, 0, 0.05)",
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                color: "rgba(0, 0, 0, 0.02)",
                            }
                        }]
                    }
                },
                doughnutOptions: {
                    responsive: true,
                    scales: {
                        xAxes: [{
                            display: false,
                            gridLines: {
                                drawBorder: false,
                                display: false
                            }
                        }],
                        yAxes: [{
                            display: false,
                            gridLines: {
                                drawBorder: false,
                                display: false
                            }
                        }]
                    }
                },
                dougnutData: {
                    labels: ['Instagram', 'Facebook', 'Twitter', 'Linkedin'],
                    datasets: [
                        {
                            backgroundColor: ['#DD2A7B', '#3B5998', '#5B9EFF', '#0E76A8'],
                            data: [20, 20, 30, 40]
                        }
                    ]
                }
            }
        },
        computed: {

        },
        mounted () {
            this.fillData()
        },
        methods: {
            fillData () {
                this.activityDataCollection = {
                    labels: ['11-06', '12-06', '13-06', '14-06', '15-06', '16-06', '17-06'],
                    datasets: [
                        {
                            label: 'Suggestions for ambassadors',
                            borderColor: "#4dc0b5",
                            backgroundColor: "#4dc0b5",
                            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
                        }, {
                            label: 'Suggestions shared',
                            borderColor: '#ffb75d',
                            backgroundColor: "#ffb75d",
                            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
                        }
                    ]
                },
                    this.timeToShareDataCollection = {
                        labels: ['11', '22', '13-06', '14-06', '15-06', '16-06', '17-06'],
                        datasets: [
                            {
                                label: 'Best time to share',
                                borderColor: "#0070D2",
                                backgroundColor: "rgba(0,112,210,0)",
                                data: [{x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}]
                            }
                        ]
                    }
            },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            }
        }
    }

</script>
<!--<style src="./Calendar.scss" scoped lang="scss"></style>-->

